import * as React from 'react';
import {ReactNode} from 'react';

export class ReactComponentWithContext<C = {}, P = {}, S = {}> extends React.Component<P, S> {
    readonly moduleContext!: C;

    constructor(props: P & Readonly<{ children?: ReactNode; moduleContext: C;}>) {
        super(props);

        this.moduleContext = props.moduleContext;
    }
}